import * as React from 'react';
const SvgScope = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M21.5 11h-1.57A7.98 7.98 0 0 0 13 4.07V2.5c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v1.57A7.98 7.98 0 0 0 4.07 11H2.5c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h1.57A7.98 7.98 0 0 0 11 19.93v1.57c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-1.57A7.98 7.98 0 0 0 19.93 13h1.57c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5M13 17.91V16.5c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v1.41A5.99 5.99 0 0 1 6.09 13H7.5c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5H6.09c.42-2.51 2.4-4.49 4.91-4.91V7.5c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5V6.09c2.51.42 4.49 2.4 4.91 4.91H16.5c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h1.41A5.99 5.99 0 0 1 13 17.91"
    />
  </svg>
);
export default SvgScope;
